export const TrendPeriod = {
  Default: _TL_('Default'),
  WOW: _TL_('Week over week'),
  MOM: _TL_('Month over month'),
  YOY: _TL_('Year over year'),
};

export const TrendPeriodLowercase = {
  Default: _TL_(''),
  WOW: _TL_('week over week'),
  MOM: _TL_('month over month'),
  YOY: _TL_('year over year'),
};

export const DefaultTrendPeriodOptions = [
  { key: 'WOW', text: _TL_('Week over week') },
  { key: 'MOM', text: _TL_('Month over month') },
  { key: 'YOY', text: _TL_('Year over year') },
];
